import { useCallback } from 'react';

import type { ISendChatStatusData } from '@type/ChatWindow';
import ioService from '../services/ioService';
import storage from '../services/localStorageService';

export const useChatStatus = () => {
  const setSendChatStatus = useCallback((statusData: ISendChatStatusData) => {
    return ioService.send({
      event: 'userStatus',
      data: {
        data: {
          status: statusData.status,
        },
        id: storage.get('id'),
        type: 'userStatus',
      },
    });
  }, []);

  return { setSendChatStatus };
};
